import { Box, styled, Typography } from "@mui/material";
import StoryText from "./StoryText";

const Wrapper = styled("div")({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "space-between",
  height: "15vh",
  padding: '5vw',
  flexWrap: "nowrap", // prevent stacking
  overflow: "hidden",  // avoid overflow issues on very small screens
});

const TextContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: 'center',
  flex: "1 1 50%", // can shrink
  minWidth: "150px", // smallest allowed width
});

const Title = styled(Typography)({
  letterSpacing: "1px",
  textTransform: "uppercase",
  fontSize: "clamp(0.5rem, 3vw, 2rem)", // shrinks dynamically
});

const Subtitle = styled(Typography)({
  fontWeight: 300,
  color: "rgba(0, 0, 0, 0.7)",
  marginTop: "8px",
  fontSize: "clamp(0.3rem, 1.5vw, 1rem)",
});

const MainTitle = () => {
  return (
    <Wrapper>
      <TextContainer>
        <Title variant="h3">STYLE YOUR WALLS</Title>
        <Subtitle variant="h6">
          Because Your Walls Deserve More Than Just Paint
        </Subtitle>
      </TextContainer>

      <StoryText />
    </Wrapper>
  );
};

export default MainTitle;
